<template>
  <BaseDialog :isOpen="isOpen">
    <template v-slot:title v-if="isEditCost">
      Edit {{ label | startCase }} Cost
    </template>
    <template v-slot:title v-else>
      Are you sure you want to {{ action }} the role on the publishing schedule
      channel?
    </template>
    <template v-slot:body>
      <v-text-field
        v-if="isEditCost"
        v-money="moneyConfig"
        label=""
        aria-label="Cost"
        prefix="£"
        v-model="cost"
      />
      <div class="send-to-agency-description" v-else>
        This will {{ action }} the role on the publishing channel
      </div>
    </template>
    <template v-slot:actions>
      <div class="send-to-agency-actions">
        <PrimaryButton @click.native="cancel" text>
          Cancel
        </PrimaryButton>
        <PrimaryButton @click.native="handleSubmit" :loading="isLoading">
          {{ buttonText | startCase }}
        </PrimaryButton>
      </div>
    </template>
  </BaseDialog>
</template>

<script>
import BaseDialog from "@/components/common/BaseDialog";
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import {
  BOOKINGS_NAMESPACE,
  TRIGGER_PUBLISHING_SCHEDULE_ACTION,
  UPDATE_PUBLISHING_SCHEDULE_COST
} from "@/store/modules/bookings/actions";
import { createNamespacedHelpers } from "vuex";
import {
  getMonetaryDisplayFormat,
  getAmountInApiFormat,
  getMonetaryAsNumber
} from "@/utils/helpers";
import { DEFAULT_CURRENCY } from "@/constants/common";

const { mapActions } = createNamespacedHelpers(BOOKINGS_NAMESPACE);

export default {
  components: { PrimaryButton, BaseDialog },
  props: {
    isOpen: Boolean,
    agency: Object,
    action: String,
    label: String,
    currentCost: Number,
    currencyCode: String
  },
  data() {
    return {
      isLoading: false,
      moneyConfig: { precision: 2 },
      cost: getMonetaryDisplayFormat(this.currentCost)
    };
  },
  inject: ["currentBookingId"],
  computed: {
    isEditCost() {
      return this.action === "editCost";
    },
    buttonText() {
      return this.isEditCost ? "Save Changes" : `${this.action} Channel`;
    }
  },
  methods: {
    ...mapActions({
      triggerAction: TRIGGER_PUBLISHING_SCHEDULE_ACTION,
      editCost: UPDATE_PUBLISHING_SCHEDULE_COST
    }),
    async handleSubmit() {
      this.isLoading = true;
      this.isEditCost
        ? await this.editCost({
            data: {
              attributes: {
                cost: getAmountInApiFormat(getMonetaryAsNumber(this.cost)),
                currencyCode: this.currencyCode || DEFAULT_CURRENCY
              },
              type: "publishing-schedules",
              id: this.agency.id
            },
            bookingId: this.currentBookingId,
            id: this.agency.id
          })
        : await this.triggerAction({
            bookingId: this.currentBookingId,
            unitId: this.agency.id,
            action: this.action
          });
      this.$emit("close");
      this.$emit("update");
      this.isLoading = false;
    },
    cancel() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss">
.send-to-agency-description {
  min-height: 100px;
}
</style>
